import ClosedTasksSwitch from './ClosedTasksSwitch';

export default ClosedTasksSwitch;
